import React from "react";
import { connect } from "react-redux";
import { Actions as INTEGRATION_ACTIONS } from "../../store/actions/integrationActions";

import { ArrowUpTrayIcon } from "@/icons/outline";

const ImportEmployeeButton = ({
	userPermissions,
	openIntegrationImportModal,
}) => {
	if (userPermissions === "Read") return null;

	return (
		<button
			type="button"
			className="btn btn-default pull-right mb-40"
			onClick={openIntegrationImportModal}
		>
			<ArrowUpTrayIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
			<div style={{ float: "left" }}>Import Employees</div>
		</button>
	);
};

const mapStateToProps = (state) => {
	return {
		userPermissions: state?.permissions?.my?.permissions?.people,
	};
};

const mapDispatchToProps = (dispatch) => ({
	openIntegrationImportModal: () => dispatch(INTEGRATION_ACTIONS.toggleImportModal(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportEmployeeButton);
